import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { RunManualStation } from '@/types/controller'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

async function runManualWithTimeStation(payload: RunManualStation): Promise<any> {
  const response: any = await controllerDataConfigApi.runManualWithTimeStation(payload)
  // axiosClient returns full AxiosResponse — actual data is in response.data
  const body = response?.data ?? response
  // API returns 200 with errorCode in body for business errors
  if (body?.errorCode) {
    throw new Error(body.errorMessage || 'Station operation failed')
  }
  return body
}
function useRunManualWithTimeStation() {
  const queryClient = useQueryClient()

  return useMutation((payload: RunManualStation) => runManualWithTimeStation(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.controller])
      queryClient.invalidateQueries([queryKeys.stations])
    },
    onError: (error: any) => {
      const message = error?.message || 'Station operation failed'
      toast.error(message)
    },
  })
}

export default useRunManualWithTimeStation
